var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[_c('h2',[_vm._v("CONTENTS")]),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/kameneko"}},[_vm._v("かめねこについて")])],1)]),_vm._v(" "),_c('router-link',{attrs:{"to":"/works/techbookfest05"}},[_vm._v("技術書典05 - 「0から始める！簡単FreeNAS構築チュートリアル！」")]),_vm._v(" "),_c('p',[_vm._v("Other Contents Coming soon...")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ae144e9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/top.vue
// module id = null
// module chunks = 